import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { DocumentoPreEditadoService } from '../../_services/DocumentoPreEditado.service';
import { DocumentoPreEditado } from '../../_models/DocumentoPreEditado';
import { Message, User } from '../../_models';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
  selector: 'app-ultimos-protocolos',
  templateUrl: './ultimos-protocolos.component.html',
  styleUrls: ['./ultimos-protocolos.component.css']
})

export class UltimosProtocolosComponent implements OnInit {
  currentUser: User;
  messageModel: Message;
  lstProtocolos = new Array<DocumentoPreEditado>();
  loadProtocolos = true as boolean;
  displayedColumns: string[] = [
    'idProtocolo',
    'documento',
    'nomeFornecedor',
    'dataCriacaoNf',
    'dataEmissaoNf',
    'dataVencimentoNf',
    'valor',
    'status',
    'select'
  ];
  dataSource = new MatTableDataSource<DocumentoPreEditado>(this.lstProtocolos);
  selection = new SelectionModel<DocumentoPreEditado>(true, []);

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private apiProtocolos: DocumentoPreEditadoService,
    private dialog?: MatDialog,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit() {
    this.apiProtocolos.obterProtocolos().subscribe(
      rtn => this.lstProtocolos = rtn.data,
      err => {
        console.log(err);

        if (err !== 'Unknown Error') {
          this.messageModel = new Message(
            'Protocolos',
            'Erro de conexão',
            'Ocorreu um erro ao listar os ultimos protocolos da base. Tente novamente.',
            'warning'
          );
          this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        }
      },
      () => {
        this.apiProtocolos.sanitizarDiretorioUpload().subscribe(err => { }, () => { });
        this.dataSource = new MatTableDataSource<DocumentoPreEditado>(this.lstProtocolos);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    ).add(() => this.loadProtocolos = false);
  }

  NavigateProtocolo(documento: string) {
    localStorage.setItem('documento', JSON.stringify(documento));
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
